{
  "title": "تفعيل سيرفر برمز",
  "description": "اكتب الرمز الظاهر على سيرفرك أثناء التثبيت لربطه بحسابك.",
  "noAccess": {
    "title": "التفعيل متاح للمالك والمدير والتقني",
    "body": "اطلب من أحدهم تفعيل السيرفر، أو اطلب تغيير دورك في الفريق."
  },
  "enter": {
    "label": "رمز التفعيل",
    "hint": "8 أحرف وأرقام، مثل K7QD-2MXR.",
    "where": "يظهر الرمز على السيرفر بعد تشغيل {{command}}.",
    "noCode": "ليس لديك رمز؟ أضف سيرفر بمفتاح التفعيل"
  },
  "error": {
    "another": "استخدام رمز آخر"
  },
  "found": {
    "title": "السيرفر الذي طلب التفعيل",
    "body": "هذا ما أرسله المثبّت مع الرمز {{code}}.",
    "expires_zero": "ينتهي الرمز خلال أقل من دقيقة.",
    "expires_one": "ينتهي الرمز خلال دقيقة.",
    "expires_two": "ينتهي الرمز خلال دقيقتين.",
    "expires_few": "ينتهي الرمز خلال {{count}} دقائق.",
    "expires_many": "ينتهي الرمز خلال {{count}} دقيقة.",
    "expires_other": "ينتهي الرمز خلال {{count}} دقيقة.",
    "check": "تأكد من أن هذا سيرفرك قبل الموافقة. لن نطلب منك هذا الرمز أبدًا عبر البريد أو الهاتف.",
    "footnote": "طلب المثبّت الرمز في الساعة {{time}}."
  },
  "choose": {
    "title": "اربط السيرفر",
    "attach": "سيرفر بانتظار التفعيل",
    "attachBody_zero": "ليس لديك سيرفرات بانتظار التفعيل.",
    "attachBody_one": "لديك سيرفر واحد أضفته ولم يتفعّل بعد.",
    "attachBody_two": "لديك سيرفران أضفتهما ولم يتفعّلا بعد.",
    "attachBody_few": "لديك {{count}} سيرفرات أضفتها ولم تتفعّل بعد.",
    "attachBody_many": "لديك {{count}} سيرفرًا أضفتها ولم تتفعّل بعد.",
    "attachBody_other": "لديك {{count}} سيرفر أضفتها ولم تتفعّل بعد.",
    "attachNone": "ليس لديك سيرفرات بانتظار التفعيل.",
    "new": "سيرفر جديد",
    "newTrial": "يبدأ ضمن تجربتك المجانية.",
    "newPaid": "اشتراك جديد، تدفع أول فترة قبل التثبيت.",
    "renames": "سنغيّر اسم المضيف من {{from}} إلى {{to}} كما أرسله السيرفر.",
    "paidNote": "بعد الموافقة تدفع أول فترة، ثم يكمل المثبّت التفعيل.",
    "approve": "الموافقة والتفعيل"
  },
  "approved": {
    "title": "تمت الموافقة",
    "body": "أرسلنا الاشتراك إلى {{host}}، وسيكمل المثبّت التفعيل خلال ثوانٍ.",
    "another": "تفعيل سيرفر آخر",
    "open": "عرض السيرفر"
  },
  "demo": {
    "title": "بيانات تجريبية: رموز للتجربة",
    "body": "في النسخة التجريبية لا يوجد مثبّت حقيقي. أنشئ رمزًا كأن سيرفرًا طلبه، أو جرّب حالات الخطأ.",
    "fresh": "محاكاة مثبّت يعرض رمزًا",
    "expired": "رمز منتهي الصلاحية",
    "used": "رمز مستخدم من قبل",
    "unknown": "رمز غير معروف"
  }
}
